import 'stylesheets/controller_based/terms/application'